export const config = {
  adminEnv: import.meta.env.VITE_APP_ADMIN_ENV,
  apiBase: import.meta.env.VITE_APP_ADMIN_API ?? '',
  firebaseApiKey: import.meta.env.VITE_APP_FIREBASE_API_KEY ?? '',
  firebaseAuthDomain: import.meta.env.VITE_APP_FIREBASE_AUTH_DOMAIN ?? '',
  firebaseTenantId: import.meta.env.VITE_APP_FIREBASE_TENANT_ID ?? ''
} as const;

export const isProd = config.adminEnv === 'production';
